// extracted by mini-css-extract-plugin
export default {"closeButton":"mZ1sg","toast":"Hii0u","icon":"mWae8","content":"ycqyf","closeIcon":"gqHKD"};